import {fabric} from 'fabric';
import {renderIcon} from '~/common/canvas/renderIcon';
import {toastAlert} from '~library/atoms/Toast';
import {AlertLineIcon} from '~library/svg/AlertLineIcon';
import DuplicateIcon from '~library/svg/icons/DuplicateIcon.svg';
import {white} from '~libSass/base/_exports.sass';
import {canvasAddTextBorderAndIcon, canvasShowTextBordersAndIcons} from '../customs/text_border';

export const cloneControl = () => {
  const cloneObject = (eventData, transform) => {
    if (transform.action === 'drag') {
      // Prevent drag action from triggering the clone control
      return;
    }
    const {target} = transform;
    const {canvas} = target;
    const textsQty = canvas.getObjects().filter((obj) => obj.type === 'textbox').length;
    if (textsQty < 8) {
      target.clone((cloned) => {
        canvas.add(
          cloned.set({
            left: target.left + 50,
            top: target.top + 50,
            text: target.text,
            letterCasing: target?.letterCasing,
            // biome-ignore lint/style/useNamingConvention: underscore
            _originalObject: JSON.parse(JSON.stringify(target)),
          })
        );
        canvas.setActiveObject(cloned);
        canvasShowTextBordersAndIcons(canvas);
        canvasAddTextBorderAndIcon(cloned, canvas, textsQty + 1);
      });
    } else {
      toastAlert('Maximum number of text boxes has been reached', {
        type: 'error',
        icon: <AlertLineIcon ratio={0.65} />,
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

  const padding = 9;

  return new fabric.Control({
    x: 0,
    y: -0.5,
    offsetX: 22,
    offsetY: -16 - padding,
    cursorStyle: 'pointer',
    mouseUpHandler: cloneObject,
    render: renderIcon({icon: DuplicateIcon, padding, fillStyle: white}),
    cornerSize: 16,
    touchSizeX: 32,
    touchSizeY: 32,
    sizeX: 30,
    sizeY: 30,
  });
};
